<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span><svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>Onze oprechte deelneming</h2>

<div modal-content class="modal-body">
    <p>Kunt u ons alstublieft een e-mail sturen met een kopie van de overlijdensakte?</p>
    <p>Als u dan in het bericht ook aangeeft hoe wij u kunnen bereiken (telefoonnummer en/of e-mailadres), nemen we snel contact met u op.</p>
    <p>Dan helpen we u graag verder.</p>
</div>
<div class="btn-group btn-group--right">
    <a
        [href]="contactQueryParams(AppRoutesEnum.Question, ContactCategoryEnum.AccidentDeath, ContactSubjectEnum.EmailContact)"
        class="btn btn--primary"
        title="Stuur een e-mail"
    >Stuur e-mail</a>
</div>
